import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { Panel, Text, Toggle } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

export const Display2ValueToggleItemBitField = ({
  register,
  tc,
  icon,
  onChange,
  options,
  inhibitText,
  disabled,
  borderOff,
  bit_number,
}) => {
  const [value, setValue] = useState(options[0].value);

  const updateValue = (value) => {
    // console.log (" Display2ValueToggleItemBitField ",value)

    var ourValue = value === false ? options[0].value : options[1].value;

    setValue(ourValue);

    const bit_field = 1 << bit_number;
    // const bit_field_mask = ( ~(1<<bit_number) );

    var theValue = register.value;
    devLog(
      ' Display2ValueToggleItemBitField ',
      value,
      'the Masked Value:',
      theValue,
      'the BitField: ',
      bit_field,
      'the BitField Mask: ',
      ~bit_field,
      'current Registre:',
      register.value,
    );

    //&= ~bit_field;
    theValue = theValue & ~bit_field; // clear the bit
    if (value) {
      theValue |= bit_field;
    }
    devLog(
      ' Display2ValueToggleItemBitField ',
      value,
      'the Masked Value:',
      theValue,
      'the BitField: ',
      bit_field,
      'the BitField Mask: ',
      ~bit_field,
      'current Registre:',
      register.value,
    );

    onChange(register, theValue);
  };

  const isChecked = () => {
    var result = false;
    if (value == options[1].value) {
      result = true;
    }
    return result;
  };

  useEffect(() => {
    const bit_field = 1 << bit_number;
    const isBitSet = (register.value & bit_field) === bit_field;
    const theValue = isBitSet ? options[1].value : options[0].value;
    setValue(theValue);
    devLog('Display2ValueToggleItemNonBitField', theValue);
  }, [register.value, bit_number, options]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4 ">
        <DisplayIcon icon={icon} />
        {!inhibitText && (
          <div className="truncate space-y-1 w-1/2">
            <Text color={tc} className="truncate">
              {register.title + '(' + bit_number + ')'}
            </Text>
            <Text color={tc} className="truncate">
              <Bold>{isChecked() ? options[1].label : options[0].label}</Bold>
            </Text>{' '}
          </div>
        )}
        <div
          className="truncate w-1/2 space-y-1"
          style={{
            display: 'block',
            width: '50%',
          }}
        >
          <Flex justifyContent="end" className="space-x-4 ">
            <Toggle
              checkedChildren={options[1].label}
              unCheckedChildren={options[0].label}
              size="lg"
              checked={isChecked()}
              disabled={disabled}
              onChange={updateValue}
            />
          </Flex>
        </div>
      </Flex>
    </Panel>
  );
};
